export const getColorAndFontManifest = () => store => {
    const { manifest = {} } = store.appReducer || {};
    const { colors = {}, fonts = {} } = manifest;

    return {
        colors,
        fonts
    };
};
